import { merge, get } from 'lodash';
import storeMixin from '@/js/store/mixins/vuex-store';
import { sortOfferMechanicPresetsByPriority } from '@/js/utils/offer-mechanic-utils';

const getInitialState = () => ({
    offerMechanicPresets: [],
});

/**
 * Inherits from the default store mixin which takes care of all CRUD operations.
 */
const store = {
    namespaced: true,

    /**
     * Default state available:
     * - loading
     */
    state: getInitialState(),

    /**
     * Default getters available:
     * - getOfferMechanicPresetsById
     */
    getters: {
        /**
         * Returns offer mechanic presets keyed by template name,
         * sorted by client-configured priority order from feature flags.
         */
        offerMechanicPresetsKeyed(state, getters, rootState) {
            const priorityOrder = get(
                rootState,
                'clientConfig.toggleLogic.offerMechanicPresetOrder',
                []
            );

            const sortedPresets = sortOfferMechanicPresetsByPriority(
                state.offerMechanicPresets,
                priorityOrder
            );
            return sortedPresets.reduce((acc, preset) => {
                acc[preset.offerTemplate] = preset.templateStructure;
                return acc;
            }, {});
        },
    },

    /**
     * Default mutations available:
     * - setLoading
     * - setOfferMechanicPresets
     * - deleteOfferMechanicPresets
     * - updateOfferMechanicPresets
     * - addOfferMechanicPresets
     * - resetState
     */
    mutations: {},

    /**
     * Default actions available:
     * - fetchOfferMechanicPresets
     * - createOfferMechanicPresets
     * - deleteOfferMechanicPresets
     * - updateOfferMechanicPresets
     * - submitForm
     * - handleResponseNotifications
     * - resetState
     */
    actions: {},
};

const mixinParams = {
    resource: 'offer-mechanic-preset',
    getInitialState,
};

export default merge({}, storeMixin(mixinParams), store);
